// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"fd2e2a67","268":"001f44c7","453":"2948b275"}[chunkId] + ".chunk.js";
};